import { directiveEntryFormSteps } from "../constants/directiveEntryFormSteps.constant";
import { MaintenanceForwardingsRequiredDirectiveStepsData } from "../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStep from "./CreateForwardingDirectiveEntryFormStep";

interface CreateForwardingDirectiveEntryFormStepsProps {
  requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData;
}

const CreateForwardingDirectiveEntryFormSteps = ({
  requiredDirectiveSteps,
}: CreateForwardingDirectiveEntryFormStepsProps) => {
  const stepKeys = Object.keys(requiredDirectiveSteps) as Array<keyof MaintenanceForwardingsRequiredDirectiveStepsData>;

  return (
    <div className="flex flex-col gap-3">
      {stepKeys.map((key, index) => {
        const directiveEntry = directiveEntryFormSteps[key];

        return (
          <CreateForwardingDirectiveEntryFormStep
            key={key}
            directiveEntryData={directiveEntry}
            attributes={requiredDirectiveSteps[key]}
            index={index}
          />
        );
      })}
    </div>
  );
}

export default CreateForwardingDirectiveEntryFormSteps;
